import { useTranslation } from "react-i18next";
import { Badge } from "@/components/ui/badge";

export type RoleKind = "worker" | "approver" | "super_admin";

function roleLabelKey(role: RoleKind) {
  switch (role) {
    case "worker":
      return "common.roles.worker.label" as const;
    case "approver":
      return "common.roles.approver.label" as const;
    case "super_admin":
      return "common.roles.super-admin.label" as const;
  }
}

export function RolePill({ role }: { role: RoleKind }) {
  const { t } = useTranslation();
  return <Badge variant="role">{t(roleLabelKey(role))}</Badge>;
}
